import { render, staticRenderFns } from "./CustomerPackages.vue?vue&type=template&id=890f7b9c&"
import script from "./CustomerPackages.vue?vue&type=script&lang=js&"
export * from "./CustomerPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports